/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaModalContent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaModalContent({
  children,
  viewPath = "/DesignSystem/TysiaModal/TysiaModalContent",
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  overflowY = "auto",
  gap,
  alignItems,
  justifyContent,
  position,
  onClose
  
}) {
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let paddingLeftOrdtSpaceS = paddingLeft ?? dtSpaceS
let paddingRightOrdtSpaceS = paddingRight ?? dtSpaceS
let paddingTopOrdtSpaceS = paddingTop ?? dtSpaceS
let paddingBottomOrdtSpaceS = paddingBottom ?? dtSpaceS
  return (<React.Fragment
>
<div
  data-testid="TysiaModalContent.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1Tkkgm': dtColorsNeutral100,'--pl-2-1Tkkgm': typeof paddingLeftOrdtSpaceS === 'number' ? `${paddingLeftOrdtSpaceS}px` : paddingLeftOrdtSpaceS,'--pr-3-1Tkkgm': typeof paddingRightOrdtSpaceS === 'number' ? `${paddingRightOrdtSpaceS}px` : paddingRightOrdtSpaceS,'--pt-4-1Tkkgm': typeof paddingTopOrdtSpaceS === 'number' ? `${paddingTopOrdtSpaceS}px` : paddingTopOrdtSpaceS,'--pb-5-1Tkkgm': typeof paddingBottomOrdtSpaceS === 'number' ? `${paddingBottomOrdtSpaceS}px` : paddingBottomOrdtSpaceS,'--oy-6-1Tkkgm': overflowY,'--g-7-1Tkkgm': typeof gap === 'number' ? `${gap}px` : gap,'--ai-8-1Tkkgm': alignItems,'--jc-9-1Tkkgm': justifyContent,'--p-10-1Tkkgm': position}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 onClose={onClose}
>
{children}
</Children>
</div>
</React.Fragment>)
}